import { Injectable, Inject, RendererFactory2, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BodyBackgroundService {
  private originalBodyBackground: string = '';
  private originalBodyBackgroundImage: string = '';
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  applyBackground(backgroundColor?: string): void {
    const body = this.document.body;

    // Save original styles only once (before applying any changes)
    if (!this.originalBodyBackground && !this.originalBodyBackgroundImage) {
      const computedStyle = window.getComputedStyle(body);
      this.originalBodyBackground = computedStyle.backgroundColor || '';
      this.originalBodyBackgroundImage = computedStyle.backgroundImage || 'none';
    }

    if (backgroundColor) {
      // Apply custom background color (case: staff with orange background)
      this.renderer.setStyle(body, 'background-color', backgroundColor);
      this.renderer.setStyle(body, 'background-image', 'none');
    } else {
      // Apply white background (case: shelter with white background)
      // This overrides any gradient or colored background from body classes
      this.renderer.setStyle(body, 'background-color', 'var(--color-background-level-0, white)');
      this.renderer.setStyle(body, 'background-image', 'none');
    }
  }

  restoreBackground(): void {
    if (this.originalBodyBackground || this.originalBodyBackgroundImage) {
      const body = this.document.body;
      if (this.originalBodyBackground) {
        this.renderer.setStyle(body, 'background-color', this.originalBodyBackground);
      } else {
        this.renderer.removeStyle(body, 'background-color');
      }
      if (this.originalBodyBackgroundImage && this.originalBodyBackgroundImage !== 'none') {
        this.renderer.setStyle(body, 'background-image', this.originalBodyBackgroundImage);
      } else {
        this.renderer.removeStyle(body, 'background-image');
      }
    }
  }
}

